<template>
  <section class="login-main-wrapper">
    <div class="container-fluid pl-0 pr-0">
      <div class="row no-gutters">
        <div class="col-md-5 p-5 bg-white full-height">
          <div class="login-main-left">
            <div class="text-center mb-5 login-main-left-header pt-4">
              <img
                src="@/assets/theme/img/favicon.png"
                class="img-fluid"
                alt="LOGO"
              >
              <h5 class="mt-3 mb-3">
                Welcome
              </h5>
              <!-- <p>It is a long established fact that a reader <br> will be distracted by the readable.</p> -->
            </div>
            <div
              v-if="error && !success"
              class="alert alert-danger"
            >
              <p>There was an error, unable to complete registration.</p>
            </div>
            <div
              v-if="success"
              class="alert alert-success"
            >
              <p>
                Registration completed. You can now
                <RouterLink to="/login">
                  sign in.
                </RouterLink>
              </p>
            </div>
            <form
              v-if="!success"
              autocomplete="off"
              method="post"
              @submit.prevent="register"
            >
              <div class="form-group">
                <label>Email</label>
                <input
                  v-model="email"
                  type="text"
                  class="form-control"
                  placeholder="Enter email"
                  required
                >
              </div>
              <div class="form-group">
                <label>Password</label>
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  required
                >
              </div>
              <!-- <div class="form-group"> -->
              <!-- <label>Promocode</label> -->
              <!-- <input type="text" class="form-control" placeholder="Promocode"> -->
              <!-- </div> -->
              <div class="mt-4">
                <button
                  type="submit"
                  class="btn btn-outline-primary btn-block btn-lg"
                >
                  Sign Up
                </button>
              </div>
            </form>
            <div class="text-center mt-5">
              <p class="light-gray">
                Already have an Account? <RouterLink to="/login">
                  Sign In
                </RouterLink>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="login-main-right bg-white p-5 mt-5 mb-5">
            <div class="owl-carousel owl-carousel-login">
              <div class="item">
                <div class="carousel-login-card text-center">
                  <img
                    src="@/assets/theme/img/login.png"
                    class="img-fluid"
                    alt="LOGO"
                  >
                  <h5 class="mt-5 mb-3">
                    Watch videos offline
                  </h5>
                  <p class="mb-4">
                    when an unknown printer took a galley of type and scrambled<br> it to make a type specimen book. It has survived not <br>only five centuries
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="carousel-login-card text-center">
                  <img
                    src="@/assets/theme/img/login.png"
                    class="img-fluid"
                    alt="LOGO"
                  >
                  <h5 class="mt-5 mb-3">
                    Download videos effortlessly
                  </h5>
                  <p class="mb-4">
                    when an unknown printer took a galley of type and scrambled<br> it to make a type specimen book. It has survived not <br>only five centuries
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="carousel-login-card text-center">
                  <img
                    src="@/assets/theme/img/login.png"
                    class="img-fluid"
                    alt="LOGO"
                  >
                  <h5 class="mt-5 mb-3">
                    Create GIFs
                  </h5>
                  <p class="mb-4">
                    when an unknown printer took a galley of type and scrambled<br> it to make a type specimen book. It has survived not <br>only five centuries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import 'owl.carousel';

export default {
  data() {
    return {
      email: '',
      password: '',
      error: false,
      errors: {},
      success: false,
    };
  },

  mounted() {
    this.initGui();
  },

  methods: {
    initGui() {
      // Login Owl Carousel
      const mainslider = $('.owl-carousel-login');
      if (mainslider.length > 0) {
        mainslider.owlCarousel({
          items: 1,
          lazyLoad: true,
          loop: true,
          autoplay: true,
          autoplaySpeed: 1000,
          autoplayTimeout: 2000,
          autoplayHoverPause: true,
        });
      }
    },

    register() {
      const app = this;
      this.$auth.register({
        data: {
          email: app.email,
          password: app.password,
        },
        success() {
          app.success = true;
        },
        error(resp) {
          app.error = true;
          app.errors = resp.response.data.errors;
        },
        redirect: null,
      });
    },
  },
};
</script>
